import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Branded error page shown when a page or recipe can't be found,
// instead of a blank screen.
const NotFound = ({
  title = "Page not found",
  message = "The page you're looking for doesn't exist or may have been moved.",
  onRetry = null,
  actionLabel = null,
  onAction = null,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#EEE7D8' }}
      data-testid="not-found-page"
    >
      <div className="text-center max-w-md">
        <img
          src="/email/wellby-logo-brown.png"
          alt="Wellby"
          width={90}
          height={56}
          className="mx-auto mb-8"
        />
        <h1
          className="mb-3"
          style={{
            color: '#51120A',
            fontFamily: "'Instrument Serif', serif",
            fontSize: '36px',
            lineHeight: 1.1,
          }}
        >
          {title}
        </h1>
        <p
          className="mb-8"
          style={{ color: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif", fontSize: '15px' }}
        >
          {message}
        </p>
        {onRetry ? (
          <Button
            onClick={onRetry}
            data-testid="load-error-retry-btn"
            className="focus:outline-none focus:ring-0"
            style={{ backgroundColor: '#51120A', borderColor: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            Try again
          </Button>
        ) : onAction && actionLabel ? (
          <Button
            onClick={onAction}
            data-testid="not-found-action-btn"
            className="focus:outline-none focus:ring-0"
            style={{ backgroundColor: '#51120A', borderColor: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            {actionLabel}
          </Button>
        ) : (
          <Button
            onClick={() => navigate('/')}
            data-testid="not-found-home-btn"
            className="focus:outline-none focus:ring-0"
            style={{ backgroundColor: '#51120A', borderColor: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            Back to Wellby
          </Button>
        )}
      </div>
    </div>
  );
};

export default NotFound;
